import { getCancellationWindow } from 'reservations/base/helpers/datetime';
import { type Fee } from 'reservations/booking/types';
import { getFormattedFeeToCharge } from 'reservations/feePolicy/helpers';

export const getLateCancelWarningText = (fee: Fee, partySize: number) =>
  `Since your reservation is in less than ${getCancellationWindow(fee.cancelDeadlineMinutes)}, you may be subject to a cancellation fee of ${getFormattedFeeToCharge(fee, partySize)}.`;
